"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRedux = require("react-redux");
var _selectors = require("../../../bus/ui/selectors");
var _Results = _interopRequireDefault(require("../../Results"));
var _Search = _interopRequireDefault(require("../../Search"));
var _constants = require("../../Search/constants");
var _GlobalLoader = _interopRequireDefault(require("../../ui/GlobalLoader"));
var _BasketCounter = require("../../Baskets/components/BasketCounter");
var _config = require("../../../services/config");
var _constants2 = require("./store/constants");
var _actions = require("./store/actions");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function Search() {
  var ui = (0, _reactRedux.useSelector)(function (store) {
    return (0, _selectors.getUI)(store, {
      key: _constants2.UI_INIT_SEARCH_PAGE_KEY
    });
  });
  var dispatch = (0, _reactRedux.useDispatch)();
  (0, _react.useEffect)(function () {
    dispatch((0, _actions.initSearchPage)());
    dispatch((0, _actions.startHandlePushOrPopHistoryForOfferDetailModal)());
    return function () {
      dispatch((0, _actions.endHandlePushOrPopHistoryForOfferDetailModal)());
    };
  }, [dispatch]);
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, ui.loading && /*#__PURE__*/_react.default.createElement(_GlobalLoader.default, null), ui.error && ui.message, ui.completed && !ui.error && /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, (0, _config.getOnGetBaskets)() && /*#__PURE__*/_react.default.createElement(_BasketCounter.BasketCounter, null), /*#__PURE__*/_react.default.createElement(_Search.default, null), /*#__PURE__*/_react.default.createElement(_Results.default, {
    queryID: _constants.MAIN_QUERY_ID
  })));
}
var _default = exports.default = (0, _react.memo)(Search);